/**
 * Profile attribute names, served paged (and server-searched) by
 * `GET /v1/environments/{environment_id}/attributes`. Names-only — each list
 * item serializes its name as `id` (Go `json:"id"`), so the reads expose
 * plain `string[]` pages rather than a row type.
 */

/** The attributes endpoint's default and maximum page size. */
export const ATTRIBUTES_PAGE_SIZE = 50;

/** Optional filters on the attribute-name reads. */
export interface AttributeListScope {
  search?: string;
  /** Only attributes currently in use (referenced by campaigns, segments, etc.). */
  inUseOnly?: boolean;
  /** Object type id: list that type's object attributes instead of people attributes. */
  objectTypeId?: string;
  /** With `objectTypeId`, list that type's relationship attributes instead of its object attributes. */
  relationship?: boolean;
}

export const attributeKeys = {
  all: ['attributes'] as const,
  catalog: (workspaceId: number, scope: AttributeListScope = {}) =>
    ['attributes', workspaceId, 'catalog', scope] as const,
  firstPage: (workspaceId: number, scope: AttributeListScope = {}) =>
    ['attributes', workspaceId, 'first-page', scope] as const,
  search: (workspaceId: number, term: string) => ['attributes', workspaceId, 'search', term] as const,
  searchInactive: (workspaceId: number) => ['attributes', workspaceId, 'search', 'inactive'] as const,
  values: (workspaceId: number, attribute: string) => ['attributes', workspaceId, 'values', attribute] as const,
  objectValues: (workspaceId: number, objectTypeId: string, attribute: string) =>
    ['attributes', workspaceId, 'object-values', objectTypeId, attribute] as const,
};
